import { render, staticRenderFns } from "./DiskList.vue?vue&type=template&id=a138ec60"
import script from "./DiskList.vue?vue&type=script&lang=js"
export * from "./DiskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports